import React, { useEffect, useState } from "react";
import {
    View,
    Text,
    TextInput,
    TouchableOpacity,
    StyleSheet,
    ScrollView,
    Alert,
} from "react-native";
import { useSelector } from "react-redux";
import getPlatformType from "../../../../../helpers/helpers";
import { MenuItem } from "@material-ui/core";
import { Select } from "@mui/material";
import { navigate } from "../../../../../navigation/RootNavigation";
import DropDownPicker from "../../../../../components/picker/DropDownPicker.web";

const layoutType = getPlatformType();

const BankAccountComponent = ({ onSave, dataa }) => {
    const bankAccounts = useSelector((state) => state?.tenant?.branchBankAccounts);

    const [selectedAccountId, setSelectedAccountId] = useState(dataa?.account?.account_id || "");
    const [payeeRef, setPayeeRef] = useState(dataa?.payeeRef || "");
    const [errors, setErrors] = useState({ account: "", payeeRef: "" });

    useEffect(() => {
        setSelectedAccountId(dataa?.account?.account_id || "");
        setPayeeRef(dataa?.payeeRef || "");
    }, [dataa?.account?.account_id, dataa?.payeeRef]);

    const selectedAccount = bankAccounts?.find(acc => acc.account_id === selectedAccountId);

    const handleSave = () => {
        const newErrors = {
            account: selectedAccount ? "" : "Please select a bank account.",
            payeeRef: payeeRef ? "" : "Please enter a payee reference."
        };

        setErrors(newErrors);

        const isValid = !newErrors.account && !newErrors.payeeRef;

        if (isValid) {
            const dataToSend = {
                account: selectedAccount,
                payeeRef
            };
            onSave?.(dataToSend);
        }
    };

    return (
        <ScrollView contentContainerStyle={styles.container}>
            <View style={styles.infoBox}>
                <Text style={styles.infoText}>
                    Please select an account from the drop down list. If there is no account listed, this can be done in the Setting tab >{" "}
                    <Text style={{ color: "#9B59B6", fontWeight: "600" }} onPress={() => navigate("BankAccount")}>
                        Bank accounts
                    </Text>. If you require further assistance please contact info@hubita.co.uk
                </Text>
            </View>

            <View style={layoutType=="web"? { flexDirection: "row", justifyContent: "space-between" }:{flexDirection:"column"}}>
                <View style={{ flex: 0.45, position: "relative" }}>
                    <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                        <Text style={[styles.link, { marginBottom: 0 }]}>Choose Bank Account</Text>
                        <TouchableOpacity onPress={() => navigate("BankAccount")}>
                            <Text style={{ color: "#9B59B6", fontWeight: "600", fontSize: 14, textDecorationLine: "underline" }}>
                                Add bank account
                            </Text>
                        </TouchableOpacity>
                    </View>
                    {bankAccounts?.length ? (
    <DropDownPicker
    title=""
    items={bankAccounts?.map((acc) => ({
      label: acc.account_name,
      value: acc.account_id
    }))}
    defaultValue={selectedAccountId}
    onChangeItem={(value) => {
        console.log("value",value)
        setSelectedAccountId(value.value)}}
  />
    ) : (
        <Text style={styles.noBankText}>Please add bank account first</Text>
    )}
                    {errors.account ? <Text style={styles.error}>{errors.account}</Text> : null}
                </View>

                <View style={{ flex: 0.45 ,marginTop:layoutType=="web"?0:16}}>
                    <Text style={styles.link}>Payee Ref</Text>
                    <TextInput
                        style={styles.input}
                        placeholder="Payee Ref"
                        value={payeeRef}
                        onChangeText={setPayeeRef}
                    />
                    {errors.payeeRef ? <Text style={styles.error}>{errors.payeeRef}</Text> : null}
                </View>
            </View>

            <View style={styles.row}><Text style={styles.label}>Account Number:</Text><Text style={styles.value}>{selectedAccount?.account_id || "-"}</Text></View>
            <View style={styles.row}><Text style={styles.label}>Sort Code:</Text><Text style={styles.value}>{selectedAccount?.sort_code || "-"}</Text></View>
            <View style={styles.row}><Text style={styles.label}>Account Name:</Text><Text style={styles.value}>{selectedAccount?.account_name || "-"}</Text></View>
            <View style={styles.row}><Text style={styles.label}>IABN:</Text><Text style={styles.value}>{selectedAccount?.iban || "-"}</Text></View>
            <View style={styles.row}><Text style={styles.label}>Swift Code:</Text><Text style={styles.value}>{selectedAccount?.swift_code || "-"}</Text></View>

            <Text style={styles.notice}>Remember to include payment reference</Text>
            <Text style={styles.notice}>Please Note: Your payment can take up to 24 hours to arrive</Text>

            <TouchableOpacity style={styles.saveButton} onPress={handleSave}>
                <Text style={styles.saveText}>SAVE</Text>
            </TouchableOpacity>
        </ScrollView>
    );
};

export default BankAccountComponent;

const styles = StyleSheet.create({
    error: {
        color: 'red',
        fontSize: 13,
        marginTop: 4,
        marginBottom:10
    },
    container: {
        flexGrow: 1,
        padding:layoutType=="web"? 24: 0,
        marginTop:layoutType=="web"?0:16,
        backgroundColor: "#fff",
    },
    infoBox: {
        backgroundColor: "#e0f2fe",
        padding: 16,
        borderRadius: 10,
        marginBottom: 24,
    },
    infoText: {
        color: "#0e7490",
        fontSize: 14,
        lineHeight: 20,
    },
    input: {
        borderWidth: 1,
        borderColor: "#ccc",
        borderRadius: 8,
        paddingVertical: 14,
        paddingHorizontal: 16,
        fontSize: 16,
        backgroundColor: "#fff",
        height: 40
    },
    link: {
        color: "#9B59B6",
        fontWeight: "600",
        fontSize: 16,
        marginBottom: 8,
    },
    row: {
        flexDirection: "row",
        flexWrap: "wrap",
        marginBottom: 8,
    },
    label: {
        fontWeight: "600",
        color: "#333",
        fontSize: 15,
    },
    value: {
        marginLeft: 6,
        color: "#888",
        fontSize: 15,
    },
    notice: {
        fontSize: 14,
        color: "#444",
        fontWeight: "500",
        marginTop: 12,
    },
    noBankText: {
        color: "#888",
        fontStyle: "italic",
        fontSize: 14,
        paddingVertical: 10,
        paddingHorizontal: 12,
        backgroundColor: "#f5f5f5",
        borderRadius: 8,
        borderWidth: 1,
        borderColor: "#ccc",
    },
    saveButton: {
        marginTop: 28,
        backgroundColor: "#9B59B6",
        paddingVertical: 10,
        borderRadius: 12,
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "center",
        width: 200,
    },
    saveText: {
        color: "#fff",
        fontSize: 16,
        fontWeight: "bold",
    },
});
